'use client';

import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { TypographyRhythm } from '@jouzen/ecom-components/v3/TypographyRhythm';
import { useLocale, useTranslations } from 'next-intl';

import RichText from '@/app/components/RichText';

import Section from '../_components/TAndCSection';
import SECTION_DATA from '../_data/sections';

const Content = () => {
  const t = useTranslations();
  const locale = useLocale();

  return (
    <LayoutGrid>
      <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
        <TypographyRhythm>
          <Typography Element="h1" variant="h2" className="uppercase">
            <RichText messageKey="b2b_terms_title" />
          </Typography>
          <Typography>
            <RichText messageKey="release_april_21_2025" />
          </Typography>
          {locale === 'ja' && (
            <Typography data-cy="japanese-disclaimer">
              <RichText messageKey="b2b_terms_translation_disclaimer" />
            </Typography>
          )}
          <Typography>
            <RichText messageKey="b2b_terms_intro_p1" />
          </Typography>
          <Typography>{t('b2b_terms_intro_p2')}</Typography>
          <Typography>{t('b2b_terms_intro_p3')}</Typography>
          <Typography>{t('b2b_terms_intro_p4')}</Typography>
          {SECTION_DATA.map((section, i) => (
            <Section {...section} index={`${i + 1}`} key={`section-${i + 1}`} />
          ))}

          <Typography className="mt-40">
            {t('legal_disclaimer_translations')}
          </Typography>
        </TypographyRhythm>
      </GridItem>
    </LayoutGrid>
  );
};

export default Content;
